import "../../home.css";

import { Link } from "react-router-dom";
import Franchise from "../Franchise";
import ContactUs from "../ContactUs";

import HomeNav from "../../Components/HomeNav";

const Home = () => {
	return (
		<div id="webcrumbs">
			<div className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-pink-50">
				<HomeNav />

				{/* Hero Section */}
				<section
					id="home"
					className="relative !bg-gradient-to-br !from-yellow-100 !via-blue-100 !to-pink-100 !py-20 overflow-hidden"
				>
					<div className="absolute inset-0 opacity-10">
						<div className="absolute top-10 left-10 w-20 h-20 bg-yellow-300 rounded-full animate-bounce"></div>
						<div className="absolute top-32 right-20 w-16 h-16 bg-pink-300 rounded-full animate-pulse"></div>
						<div className="absolute bottom-20 left-1/4 w-12 h-12 bg-blue-300 rounded-full animate-bounce"></div>
						<div className="absolute bottom-32 right-1/3 w-14 h-14 bg-orange-300 rounded-full animate-pulse"></div>
					</div>
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
							<div className="text-center lg:text-center">
								<h1 className="!text-4xl sm:!text-5xl lg:!text-6xl font-bold text-gray-800 !mb-6">
									Empower Young Minds with
									<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">
										{" "}
										EliteMindMap!
									</span>
								</h1>
								<p className="!text-xl text-gray-600 mb-8 !my-3 leading-relaxed">
									Brain development academy for children with
									higher cognitive skills through Abacus,
									Handwriting, and creative learning programs.
								</p>
								<div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-center">
									<Link
										to="/signin"
										className="!bg-gradient-to-r !no-underline !from-blue-500 !to-purple-500 !text-white !px-8 !my-4 !py-4 !rounded-full !text-lg !font-bold hover:!shadow-xl !transform hover:!scale-105 !transition-all !duration-300"
									>
										🚀 Start Learning Now!
									</Link>
								</div>
							</div>
							<div className="relative">
								<img
									src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop&crop=center"
									alt="Happy diverse children learning with colorful educational materials including abacus and books"
									keywords="children, kids, learning, education, abacus, colorful, diverse, happy, classroom, cognitive skills"
									className="w-full h-auto rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
								/>
								<div className="absolute -top-4 -right-4 bg-yellow-400 text-white p-3 rounded-full shadow-lg animate-bounce">
									<span className="!text-2xl">⭐</span>
								</div>
								<div className="absolute -bottom-4 -left-4 bg-pink-400 text-white p-3 rounded-full shadow-lg animate-pulse">
									<span className="!text-2xl">🎯</span>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* About EliteMindMap Section */}
				<section id="about" className="py-20 bg-white">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<h2 className="!text-4xl font-bold text-gray-800 mb-4">
								About EliteMindMap & Why Us
							</h2>
							<div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-pink-500 mx-auto rounded-full"></div>
							<p className="!text-lg text-gray-700 mt-6 max-w-4xl mx-auto leading-relaxed">
								EliteMindMap is an academy for children's brain
								development with higher cognitive skills. We
								provide learning platforms to children who wish
								to equip themselves with creative, logical, and
								analytical skills through our brain-teasing
								activities and courses. These time-tested proven
								activities have empowered many personalities in
								the past and are helping many in recent times.
							</p>
						</div>

						{/* Vision */}
						<div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-3xl p-8 mb-12">
							<h3 className="!text-2xl font-bold text-gray-800 mb-4 text-center">
								Our Vision
							</h3>
							<p className="text-gray-700 text-center !text-lg leading-relaxed">
								To empower young minds with competitive
								intelligence and expressive temperament by
								sharpening cognitive and soft-skill talents.
							</p>
						</div>

						{/* Why Us Grid */}
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
							<div className="text-center p-8 bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">👨‍🏫</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Experienced Mentors
								</h3>
								<p className="text-gray-600">
									Trainers with years of experience in
									training students in related courses and
									brain developmental activities
								</p>
							</div>
							<div className="text-center p-8 bg-gradient-to-br from-pink-50 to-pink-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">🎯</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Personalized Approach
								</h3>
								<p className="text-gray-600">
									Individual attention and personalized
									approach toward every student
								</p>
							</div>
							<div className="text-center p-8 bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">📊</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Regular Assessment
								</h3>
								<p className="text-gray-600">
									Assessment to gauge the development of
									students and track progress
								</p>
							</div>
							<div className="text-center p-8 bg-gradient-to-br from-green-50 to-green-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">🎮</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Interactive Sessions
								</h3>
								<p className="text-gray-600">
									Engaging and interactive sessions that make
									learning fun
								</p>
							</div>
							<div className="text-center p-8 bg-gradient-to-br from-purple-50 to-purple-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">👥</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Small Batches
								</h3>
								<p className="text-gray-600">
									Small batches for addressing individual
									concerns and providing focused attention
								</p>
							</div>
							<div className="text-center p-8 bg-gradient-to-br from-orange-50 to-orange-100 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300">
								<div className="!text-6xl mb-4">🏆</div>
								<h3 className="!text-xl font-bold text-gray-800 mb-4">
									Competition Support
								</h3>
								<p className="text-gray-600">
									Support for student's participation in
									regional/national level competitions
								</p>
							</div>
						</div>
					</div>
				</section>

				{/* Our Programs Section */}
				<section
					id="programs"
					className="py-20 !bg-gradient-to-br !from-purple-50 !to-blue-50"
				>
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<h2 className="!text-4xl font-bold text-gray-800 mb-4">
								Our Programs
							</h2>
							<p className="!text-xl text-gray-600">
								Comprehensive courses designed to develop
								cognitive skills and unleash potential!
							</p>
							<div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full mt-4"></div>
						</div>

						{/* Program 1: Abacus */}
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
							<div className="order-2 lg:order-1">
								<div className="bg-white rounded-3xl p-8 shadow-xl">
									<div className="flex items-center mb-6">
										<div className="!text-6xl mr-4">🧮</div>
										<h3 className="!text-3xl font-bold text-gray-800">
											Abacus Program
										</h3>
									</div>
									<p className="text-gray-700 mb-6 leading-relaxed">
										Abacus is one of the oldest computing
										devices invented 5000 years ago and
										still used worldwide. With regular use,
										students develop the ability to
										visualize and calculate mentally,
										activating both sides of the brain for
										whole brain development.
									</p>
									<div className="mb-6">
										<h4 className="font-bold text-gray-800 mb-3">
											Benefits:
										</h4>
										<ul className="space-y-2 text-gray-700">
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Improves numerical skills and
												mental calculation ability
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Enhances learning ability and
												thinking skills
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Improves visualization and
												concentration
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Activates both brain hemispheres
												(abstract & logical)
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Increases speed in computing and
												problem-solving
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Evades the fear of mathematics
												in young minds
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="order-1 lg:order-2">
								<img
									src="https://images.unsplash.com/photo-1596496050827-8299e0220de1?w=600&h=400&fit=crop&crop=center"
									alt="Children learning abacus calculation with colorful beads"
									className="w-full h-auto rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
								/>
							</div>
						</div>

						{/* Program 2: Handwriting */}
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
							<div>
								<img
									src="https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600&h=400&fit=crop&crop=center"
									alt="Child practicing beautiful handwriting with pen and paper"
									className="w-full h-auto rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
								/>
							</div>
							<div>
								<div className="bg-white rounded-3xl p-8 shadow-xl">
									<div className="flex items-center mb-6">
										<div className="!text-6xl mr-4">✍️</div>
										<h3 className="!text-3xl font-bold text-gray-800">
											Handwriting Course
										</h3>
									</div>
									<p className="text-gray-700 mb-6 leading-relaxed">
										Your signature and handwriting leave a
										lasting impression. Legible, stylish,
										and beautiful handwriting not only
										attracts attention but reveals
										personality traits. Writing by hand
										activates brain parts associated with
										working memory, reading, and language.
									</p>
									<div className="mb-6">
										<h4 className="font-bold text-gray-800 mb-3">
											What We Teach:
										</h4>
										<ul className="space-y-2 text-gray-700 mb-4">
											<li className="flex items-start">
												<span className="text-blue-500 mr-2">
													•
												</span>
												Complete formation of letters
												and spacing
											</li>
											<li className="flex items-start">
												<span className="text-blue-500 mr-2">
													•
												</span>
												Uniformity and alignment of
												letters/words
											</li>
											<li className="flex items-start">
												<span className="text-blue-500 mr-2">
													•
												</span>
												Writing speed improvement
												techniques
											</li>
											<li className="flex items-start">
												<span className="text-blue-500 mr-2">
													•
												</span>
												Different writing styles:
												cursive, print, italics
											</li>
										</ul>
										<h4 className="font-bold text-gray-800 mb-3">
											Benefits:
										</h4>
										<ul className="space-y-2 text-gray-700">
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Legible and neat writing skills
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Improved concentration and
												memorization
											</li>
											<li className="flex items-start">
												<span className="text-green-500 mr-2">
													✓
												</span>
												Enhanced reading and learning
												skills
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Gallery Section */}
				<section id="gallery" className="py-20 bg-white">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<h2 className="!text-4xl font-bold text-gray-800 mb-4">
								Learning Gallery
							</h2>
							<p className="!text-xl text-gray-600">
								Discover the amazing world of EliteMindMap
								through our exciting programs and activities!
							</p>
							<div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full mt-4"></div>
						</div>
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1588072432836-e10032774350?w=400&h=300&fit=crop&crop=center"
									alt="Classroom session with children learning abacus"
									keywords="classroom, abacus, children, learning, education"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Abacus Training
									</h3>
									<p className="!text-sm">
										Mental math mastery sessions!
									</p>
								</div>
							</div>
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop&crop=center"
									alt="Children in interactive learning circle"
									keywords="children, circle, learning, interactive, group"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Interactive Sessions
									</h3>
									<p className="!text-sm">
										Engaging group learning activities!
									</p>
								</div>
							</div>
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1567653418876-5bb0e566e1c2?w=400&h=300&fit=crop&crop=center"
									alt="Happy children celebrating achievement"
									keywords="children, celebrating, achievement, happy, success"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Achievement Celebration
									</h3>
									<p className="!text-sm">
										Celebrating student milestones!
									</p>
								</div>
							</div>
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1573164713619-24c711fe7878?w=400&h=300&fit=crop&crop=center"
									alt="Team of children collaborating on activities"
									keywords="team, children, collaboration, activities, teamwork"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Team Challenges
									</h3>
									<p className="!text-sm">
										Working together to solve problems!
									</p>
								</div>
							</div>
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=300&fit=crop&crop=center"
									alt="Interactive learning with digital tools"
									keywords="interactive, learning, digital, technology, education"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Modern Learning
									</h3>
									<p className="!text-sm">
										Technology-enhanced education!
									</p>
								</div>
							</div>
							<div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300">
								<img
									src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=300&fit=crop&crop=center"
									alt="Children in focused learning session"
									keywords="children, focused, learning, concentration, study"
									className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
								/>
								<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
								<div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									<h3 className="!text-lg font-bold">
										Focused Learning
									</h3>
									<p className="!text-sm">
										Building concentration skills!
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Franchise Section */}
				<section
					id="franchise"
					className="py-20 bg-gradient-to-br from-blue-50 to-purple-50"
				>
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
							<div>
								<h2 className="!text-4xl font-bold text-gray-800 mb-6">
									Join Our Franchise Family!
								</h2>
								<p className="!text-xl text-gray-600 !mb-8 !my-3">
									Become a part of the EliteMindMap revolution
									and bring educational excellence to your
									community. Our proven business model helps
									you create a successful learning center.
								</p>
								<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
									<div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl">
										<div className="!text-3xl">🏅</div>
										<div>
											<h4 className="font-bold text-gray-800">
												Certified Training
											</h4>
											<p className="!text-sm text-gray-600">
												Complete support system
											</p>
										</div>
									</div>
									<div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-green-50 to-green-100 rounded-2xl">
										<div className="!text-3xl">💰</div>
										<div>
											<h4 className="font-bold text-gray-800">
												Profitable Business
											</h4>
											<p className="!text-sm text-gray-600">
												High ROI guaranteed
											</p>
										</div>
									</div>
									<div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-purple-50 to-purple-100 rounded-2xl">
										<div className="!text-3xl">🤝</div>
										<div>
											<h4 className="font-bold text-gray-800">
												Ongoing Support
											</h4>
											<p className="!text-sm text-gray-600">
												24/7 assistance
											</p>
										</div>
									</div>
									<div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl">
										<div className="!text-3xl">📈</div>
										<div>
											<h4 className="font-bold text-gray-800">
												Marketing Tools
											</h4>
											<p className="!text-sm text-gray-600">
												Ready-to-use materials
											</p>
										</div>
									</div>
								</div>
								<Franchise />
							</div>
							<div className="relative">
								<img
									src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop&crop=center"
									alt="Professional learning center with happy children and teachers in bright educational environment"
									keywords="learning center, children, teachers, professional, educational, bright, happy, classroom"
									className="w-full h-auto rounded-3xl shadow-2xl"
								/>
								<div className="absolute -top-6 -right-6 !bg-gradient-to-r !from-pink-500 !to-purple-500 text-white p-4 rounded-full !shadow-lg">
									<span className="!text-2xl font-bold">
										TOP
									</span>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Contact Section */}
				<section
					id="contact"
					className="py-20 !bg-gradient-to-br !from-pink-50 via-purple-50 !to-blue-50"
				>
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<h2 className="!text-4xl font-bold text-gray-800 mb-4">
								Get in Touch!
							</h2>
							<p className="!text-xl text-gray-600">
								Have questions? Our friendly team is here to
								help you!
							</p>
							<div className="w-24 h-1 !bg-gradient-to-r !from-pink-500 !to-purple-500 mx-auto rounded-full mt-4"></div>
						</div>
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
							<div className="bg-white rounded-3xl p-8 shadow-xl">
								<h3 className="!text-2xl font-bold text-gray-800 mb-6">
									Send us a Message
								</h3>
								<ContactUs />
							</div>
							<div className="space-y-8">
								<div className="text-center">
									<div className="inline-block p-6 !bg-gradient-to-br !from-yellow-100 !to-orange-100 rounded-full mb-4">
										<span className="!text-6xl">🎓</span>
									</div>
									<h3 className="!text-2xl font-bold text-gray-800 mb-2">
										Education Partner
									</h3>
									<p className="text-gray-600">
										We're here to help you with any
										questions about our amazing learning
										programs!
									</p>
								</div>
								<div className="bg-white rounded-3xl p-6 shadow-lg">
									<h4 className="!text-xl font-bold text-gray-800 mb-4">
										Contact Information
									</h4>
									<div className="space-y-4">
										<div className="flex items-center space-x-3">
											<div className="w-10 h-10 !bg-gradient-to-r !from-blue-400 !to-purple-400 rounded-full flex items-center justify-center">
												<span className="material-symbols-outlined text-white !text-sm">
													call
												</span>
											</div>
											<div>
												<p className="font-medium text-gray-800">
													Phone
												</p>
												<p className="text-gray-600">
													+91 8105318798 <br /> +91
													9108445621
												</p>
											</div>
										</div>
										<div className="flex items-center space-x-3">
											<div className="w-10 h-10 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center">
												<span className="material-symbols-outlined text-white !text-sm">
													email
												</span>
											</div>
											<div>
												<p className="font-medium text-gray-800">
													Email
												</p>
												<p className="text-gray-600">
													elitemindmap@gmail.com
												</p>
											</div>
										</div>
										<div className="flex items-center space-x-3">
											<div className="!w-10 !h-10 bg-gradient-to-r from-pink-400 to-orange-400 rounded-full flex items-center justify-center">
												<span className="material-symbols-outlined text-white !text-sm">
													location_on
												</span>
											</div>
											<div>
												<p className="font-medium text-gray-800">
													Address
												</p>
												<p className="text-gray-600">
													#5/4, 2nd floor, 1st main,
													1st stage, KHB Colony,
													Basaveshwaranagar, Bengaluru
													- 560079
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Footer */}
				<footer className="bg-gray-800 text-white py-12">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
							<div>
								<h3 className="!text-2xl font-bold mb-4">
									<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">
										{" "}
										EliteMindMap
									</span>
								</h3>
								<p className="text-gray-300 mb-4">
									Empowering young minds with cognitive skills
									through Abacus, Handwriting, and creative
									learning programs.
								</p>
								<div className="flex space-x-4">
									<a
										href="#"
										className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200"
									>
										<i className="fa-brands fa-facebook text-white"></i>
									</a>
									<a
										href="#"
										className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors duration-200"
									>
										<i className="fa-brands fa-instagram text-white"></i>
									</a>
									<a
										href="#"
										className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors duration-200"
									>
										<i className="fa-brands fa-twitter text-white"></i>
									</a>
								</div>
							</div>
							<div>
								<h4 className="!text-lg font-semibold mb-4">
									Quick Links
								</h4>
								<ul className="space-y-2">
									<li>
										<a
											href="#home"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Home
										</a>
									</li>
									<li>
										<a
											href="#about"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											About Us
										</a>
									</li>
									<li>
										<a
											href="#programs"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Programs
										</a>
									</li>
									<li>
										<a
											href="#gallery"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Gallery
										</a>
									</li>
									<li>
										<a
											href="#franchise"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Franchise
										</a>
									</li>
								</ul>
							</div>
							<div>
								<h4 className="!text-lg font-semibold mb-4">
									Support
								</h4>
								<ul className="space-y-2">
									<li>
										<a
											href="#"
											className="!text-gray-300 !no-underline hover:!text-white transition-colors duration-200"
										>
											Help Center
										</a>
									</li>
									<li>
										<a
											href="#"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Privacy Policy
										</a>
									</li>
									<li>
										<a
											href="#"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Terms of Service
										</a>
									</li>
									<li>
										<a
											href="#contact"
											className="!text-gray-300 !no-underline hover:text-white transition-colors duration-200"
										>
											Contact Us
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="border-t border-gray-700 mt-8 pt-8 text-center">
							<p className="text-gray-300">
								&copy; 2024 EliteMindMap. All rights reserved.
								Made with ❤️ for amazing kids!
							</p>
						</div>
					</div>
				</footer>
			</div>
		</div>
	);
};
export default Home;

